var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"info-modal\">\n<div class=\"modal-header\">\n<div class=\"row\">\n<div class=\"col-xs-10\">\n<h1 translate>Lisätietoja</h1>\n</div>\n<div class=\"col-xs-2\">\n<icon-button id=\"close-button\" class=\"pull-right modal-close-button\" icon=\"icon-x\" no-border=\"true\" click-action=\"$ctrl.close()\" label=\"{{'Sulje' | translate}}\"></icon-button>\n</div>\n</div>\n</div>\n<div class=\"modal-body text-body\">\n<div class=\"tab-container\" ng-if=\"$ctrl.tabs.length > 1\">\n<mdc-tab-bar tab-items=\"$ctrl.tabs\" on-item-selected=\"$ctrl.tabSelected(index)\"></mdc-tab-bar>\n</div>\n<div ng-include=\"$ctrl.activeTpl\"></div>\n</div>\n</div>\n";
var id1="app/common/components/infomodal/infomodal.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/infomodal/infomodal.tpl.html
// module id = 464
// module chunks = 0